module.exports = __webpack_public_path__ + "img/blazer.df23f20a.png";